// src/pages/dashboards/user/UserReceipts.jsx
// Scanned receipts as a table; click a row to view line items + the image.

import React, { useEffect, useState } from "react";
import { listReceipts } from "../../../api/user";
import { Card, Loading, EmptyState, Modal, Badge, Input } from "../../../components/ui";
import ReceiptPanel from "../../../components/ReceiptPanel";
import { useToast } from "../../../context/ToastContext";
import { money, date } from "../../../lib/format";

export default function UserReceipts() {
  const toast = useToast();
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    listReceipts().then(setRows).catch((e) => toast.error(e.message));
    /* eslint-disable-next-line */
  }, []);

  const filtered = (rows || []).filter((r) =>
    !q.trim() || (r.merchant || "").toLowerCase().includes(q.trim().toLowerCase())
  );

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <h1 className="text-2xl font-bold">Receipts</h1>
        {rows && rows.length > 0 && (
          <Input placeholder="Search merchant" value={q} onChange={(e) => setQ(e.target.value)} className="w-full sm:w-64" />
        )}
      </div>

      <Card className="overflow-hidden">
        {!rows ? <Loading label="Loading receipts" /> : rows.length === 0 ? (
          <EmptyState title="No receipts" hint="Receipts you scan in the app show up here." />
        ) : filtered.length === 0 ? (
          <EmptyState title="No matches" hint="Try a different merchant name." />
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-tb-muted border-b border-tb-border dark:border-tb-d-border">
                  <th className="px-4 py-3 font-medium">Merchant</th>
                  <th className="px-4 py-3 font-medium hidden sm:table-cell">Date</th>
                  <th className="px-4 py-3 font-medium text-center">Items</th>
                  <th className="px-4 py-3 font-medium text-right">Total</th>
                  <th className="px-4 py-3"></th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((r) => (
                  <tr key={r.id}
                      onClick={() => setOpen(r)}
                      className="border-b border-tb-border dark:border-tb-d-border last:border-0 hover:bg-tb-bg-2 dark:hover:bg-tb-d-inset cursor-pointer transition-colors">
                    <td className="px-4 py-3 font-medium">{r.merchant || "Unknown merchant"}</td>
                    <td className="px-4 py-3 text-tb-muted hidden sm:table-cell">{date(r.receipt_date)}</td>
                    <td className="px-4 py-3 text-center">
                      <Badge tone="gray">{r.item_count}</Badge>
                    </td>
                    <td className="px-4 py-3 text-right font-medium tabular-nums">{money(r.total)}</td>
                    <td className="px-4 py-3 text-right">
                      <span className="text-xs text-tb-brand">View</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>

      {open && (
        <Modal open onClose={() => setOpen(null)} title={open.merchant || "Receipt"} width="max-w-3xl" bodyClassName="p-6">
          <ReceiptPanel receiptId={open.id} />
        </Modal>
      )}
    </div>
  );
}